/**
 * Look for environment variables in the following places:
 *
 * window.variables - Used when serving the application from within lsco-building-app
 * process.env - Used when serving the app from the development environment or serving the app statically.
 *               the variable name is prefixed with "REACT_APP_", uppercased and all dots converted to underscores.
 *               (This keeps it inline with naming conventions used by Create React App)
 *
 * If the variable is not found in either place the defaultValue is returned
 * @param variable
 * @param defaultValue
 * @returns {*}
 */
export default function envDefault(variable, defaultValue) {
  let value = (window.variables && window.variables[variable]) || undefined;
  if(typeof value !== "undefined")
  {
    console.info("Found environment variable " + variable + " with value of: '" + value + "' in window variables")
    return value
  }
  else
  {
    value = process.env[getReactName(variable)]
    if(typeof value !== "undefined")
    {
      console.info("Found environment variable " + variable + " with value of: '" + value + "' in processs.env")
      return value
    }
    else
    {
      console.info("No environment variable with name: " + variable + " found. Defaulting to: '" + defaultValue + "'")
      return defaultValue
    }
  }
}

/**
 * Convert a environment variable name to a react environment variable name.
 *
 * eg.
 *
 * building.host
 *
 * becomes:
 *
 * REACT_APP_BUILDING_HOST
 */
function getReactName(variableName)
{
  return 'REACT_APP_'+ variableName.toUpperCase().replace(/\./g,'_')
}